import { URLs } from "@/constants";
import type { IApiRequest, IApp } from "@/types";
import { apiURL, sendRequest } from "@/utils";

namespace Report {
  export const create = async (report: IApiRequest.ReportCreateInput) => {
    return await sendRequest<{ message: string; requestId: string }>({
      url: apiURL(URLs.API_REPORT_CREATE),
      method: "POST",
      data: report
    });
  };

  export const list = async () => {
    return await sendRequest<{ reports: IApp.IReport[] }>({
      url: apiURL(URLs.API_REPORT_LIST),
      method: "GET"
    });
  };

  export const get = async (requestId: string, reportId: string) => {
    return await sendRequest<{ report: IApp.IReport }>({
      url: apiURL(URLs.API_REPORT_GET(requestId, reportId)),
      method: "GET"
    });
  };

  export const generateSummary = async (prompt: string) => {
    return await sendRequest<{ summary: string }>({
      url: apiURL(URLs.API_REPORT_SUMMARY_GENERATE),
      method: "POST",
      data: { prompt }
    });
  };

  export const updateSummary = async (
    requestId: string,
    reportId: string,
    summary: string,
    promptId: string | null
  ) => {
    return await sendRequest<{ message: string }>({
      url: apiURL(URLs.API_REPORT_SUMMARY_UPDATE(requestId, reportId)),
      method: "PUT",
      data: { summary, promptId }
    });
  };

  export const confirmReport = async (requestId: string, reportId: string) => {
    return await sendRequest<{ message: string }>({
      url: apiURL(URLs.API_REPORT_CONFIRM(requestId, reportId)),
      method: "POST"
    });
  };

  export const getPrompt = async () => {
    return await sendRequest<{ prompt: string }>({
      url: apiURL(URLs.API_REPORT_PROMPT_GET),
      method: "GET"
    });
  };

  export const updatePrompt = async (prompt: string) => {
    return await sendRequest({
      url: apiURL(URLs.API_REPORT_PROMPT_UPDATE),
      method: "PUT",
      data: { prompt }
    });
  };
}

export default Report;
